import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Bills from './pages/Bills/Bills';
import BillDetail from './pages/BillDetail/BillDetail';
import StateBills from './pages/StateBills/StateBills';
import StateBillDetail from './pages/StateBillDetail/StateBillDetail';
import Legislators from './pages/Legislators/Legislators';
import NotFound from './pages/NotFound';
import Homepage from './pages/Homepage/Homepage';
import Route from './Route';
import Resources from './pages/Resources/Resources';

function App() {
  return (
    <div style={{ width: '100%', overflow: 'hidden' }}>
      <a href="#main-content" className="skip-link">
        Skip to main content
      </a>
      <Header />
      <main id="main-content" tabIndex={-1} style={{ width: '100%', overflow: 'hidden' }}>
        <Route path="/">
        <Homepage />
      </Route>
      <Route path="/bills">
        <Bills />
      </Route>
      <Route path="/details">
        <BillDetail />
      </Route>
      <Route path="/state-bills">
        <StateBills />
      </Route>
      <Route path="/state-bill-details">
        <StateBillDetail />
      </Route>
      <Route path="/legislators">
        <Legislators />
      </Route>
      <Route path="/resources">
        <Resources />
      </Route>
        <Route path="*">
          <NotFound />
        </Route>
      </main>
      <Footer />
    </div>
  );
}

export default App;
